import { render, staticRenderFns } from "./PlatformSelect.vue?vue&type=template&id=8cdb4552&scoped=true&"
import script from "./PlatformSelect.vue?vue&type=script&lang=js&"
export * from "./PlatformSelect.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSelect.vue?vue&type=style&index=0&id=8cdb4552&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdb4552",
  null
  
)

export default component.exports